<template>
    <app-content-admin>
        <template slot="header">{{$t("merchant")}}</template>

        <v-layout row wrap no-gutters>
            <v-flex xs12>
                <v-form @submit.prevent="search(10,1)" autocomplete="off">
                    <v-layout row wrap>
                        <v-flex xs12 sm3>
                            <v-text-field
                                :label="$t('A00050')"
                                type="date"
                                v-model="form.from_date"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                :label="$t('A00051')"
                                type="date"
                                v-model="form.to_date"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-btn color="primary" type="submit" class="form-submit mr-4">{{$t('A00054')}}</v-btn>
                            <v-btn color="secondary" @click="reset" class="form-submit mr-4">{{$t('A00243')}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>

            <v-flex xs12>
                <v-card class="pa-3">
                <table class="table table-fluid no-wrap">
                    <thead>
                        <th scope="col">{{ $t('brand') }}</th>
                        <th scope="col">{{ $t('short_brand') }}</th>
                        <th scope="col">{{ $t('status') }}</th>
                        <th scope="col">{{ $t('created_at') }}</th>
                        <th scope="col">{{ $t('action') }}</th>
                    </thead>
                    <tbody>
                    <tr class="text-center" v-for="row in rows" :key="row.id">
                        <td :data-label="$t('brad')">{{ row.brand }}</td>
                        <td :data-label="$t('short_brand')">{{ row.short_brand }}</td>
                        <td :data-label="$t('status')">
                            <active-label :status="row.status"></active-label>
                        </td>
                        <td :data-label="$t('created_at')">{{ row.created_at }}</td>
                        <td :data-label="$t('action')">

                            <v-tooltip bottom v-can="'merchant_edit'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="$router.push({name: 'merchant_edit', params: {id: row.id}})">
                                        <v-icon
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-pencil-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('edit') }}</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="row.status == 'pending' && $can('merchant_approve')">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="approve(row.id)">
                                        <v-icon
                                            color="success"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-check
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('approve') }}</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="row.status == 'inactive' && $can('merchant_approve')">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="resendEmail(row.id)">
                                        <v-icon
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-reload
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('resend_activation_email') }}</span>
                            </v-tooltip>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <v-layout justify-center>
                    <v-flex xs8>
                        <div class="text-xs-center"  v-if="pages > 0">
                            <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
                        </div>
                    </v-flex>
                </v-layout>
                </v-card>
            </v-flex>

        </v-layout>
    </app-content-admin>

</template>

<script>
import ActiveLabel from '@/components/status/ActiveLabel'

export default {
    data() {
        return {
            rows:[],
            pages:0,
            page:1,
            rules: {
                required: value => !!value || this.$t('W00023'),
                min: v => v.length >= 6 || this.$t('W00022')
            },
            form: {
                offset:10,
                page:1,
            },
        }
    },

    components: {
        ActiveLabel
    },

    mounted() {
        this.search();
    },

    methods: {
        search(offset = 10, page = 1) {
            this.form.offset = offset;
            this.form.page = page;

            let loader = this.$loading.show();

            axios.post(api.path('merchant.list'), this.form)
                .then(res => res.data)
                .then(res => {
                    this.rows = res.data.data;
                    this.pages = res.data.pages;
                })
                .catch(e=>{
                    this.$toastr.e(e.message);
                })
                .finally(()=>{
                    loader.hide();
                })
        },

        async approve(id) {
            let loader = this.$loading.show();
            await axios.post(api.path('merchant.approve'), {id: id})
                .then(res => res.data)
                .then(res => {
                    this.search(this.form.offset, this.form.page)
                    this.$toastr.s(res.message);
                });

            loader.hide();
        },

        async resendEmail(id) {
            let loader = this.$loading.show();
            await axios.post(api.path('merchant.resend'), {id: id})
                .then(res => res.data)
                .then(res => {
                    this.$toastr.s(res.message);
                });

            loader.hide();
        },

        onListChange(page) {
            this.page = page;
            this.search(10, page);
        },

        reset(){
          this.form.offset=10
          this.form.page=1
          this.form.from_date=''
          this.form.to_date=''
          this.form.email=''
          this.form.username=''
          this.form.name=''
          this.form.country=''
          this.form.ranking=''
        },

        editCompany(company_id) {
            this.$router.push("/company/edit/"+company_id);
        },

        companyInfo(company_id) {
            this.$router.push("/company/read/"+company_id);
        },

        ownerAction(company_id) {
             this.$router.push("/company/approve/"+company_id);
        }
    }
}
</script>